import { PaywallMode } from '@nx-frontend/shared/types/paywall-types';

export const mapMode: Record<PaywallMode, string> = {
  trialStart: 'trial_start',
  trialEnd: 'trial_end',
  upgrade: 'upgrade',
  addons: 'addons',
};
